import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import restApi from '../restApi';
import endpoints from "../../config/endpoints";

interface homeState {
  loading: boolean;
  statuses: any;
  brands: any[];
}

const initialState: homeState = {
  loading: false,
  statuses: {},
  brands: []
};


const statuses = createAsyncThunk('status/fetch', async () => {
  return await restApi(process.env.REACT_APP_BASE_URL + '/order/status').get();
});

const brands = createAsyncThunk('brands/fetch', async () => {
  return await restApi(endpoints.brand.index, true).get();
})

const homeSlice = createSlice({
  name: 'homeReducer',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }, extraReducers: (builder) => {
    builder.
      addCase(statuses.fulfilled, (state, action) => {
        if (action.payload.code == 200){
          action.payload.data?.map((status) => state.statuses[status.id] = status )
        }
    })
      .addCase(brands.fulfilled, (state, action) => {
        state.brands = action.payload?.data
      })
  }
});

export const {
  setLoading
} = homeSlice.actions;

export {
  statuses,
  brands
}
const homeReducer = homeSlice.reducer;

export default homeReducer;
